
export class BackButton {
  className = "c-backbtn";

  constructor(el) {
    this.el = el;

    if (!this.el) {
      console.warn("BackBtn: elemento non fornito");
      return;
    }

    this.init();
  }

  init() {
    this.el.classList.add(this.className);

    this.el.addEventListener("click", (e) => {
      e.preventDefault();
      this.goBack();
    });
  }

  goBack() {
    if (document.referrer !== "") {
        window.history.back();
    } else {
      window.location.href = "/";
    }
  }
}
